import { parseMillisToString } from "../../dao";


export class Message {
  constructor(timestamp, body) {
    this.timestamp = timestamp;
    this.body = body;
    this.reactObj = (<div className="message" key={`${timestamp}${body}`}>
      <small>{parseMillisToString(this.timestamp)}</small>
      <p>{this.body}</p>
    </div>);
  }

  static messagesFromJson(jsonObjs) {
    let allMessages = [];
    for (const entry of jsonObjs) {
      for (const [timestamp, messages] of Object.entries(entry)) {
        let msg = new Message(parseInt(timestamp), messages);
        allMessages.push(msg);
      }
    }
    return allMessages;
  }

  toJson() {
    return { [this.timestamp]: this.body }
  }
}
